export enum ActionTypes {
    FETCH_FEES = 'app/table/FETCH_FEES)',
    FETCH_FEE_GROUPS = 'app/table/FETCH_FEE_GROUPS)',
}